import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { PricePipeModule } from 'src/app/pipes/price.module';
import { EntryFeeCalcComponent } from './entry-fee-calc.component';
import { PreloadSpinnerModule } from '../preload-spinner/preload-spinner.module';
import { EntryFeeCalcItemComponent } from './entry-fee-calc-item/entry-fee-calc-item.component';
import { EntryFeeInfoItemComponent } from './entry-fee-info-item/entry-fee-info-item';
import { TooltipButtonModule } from '../tooltip-button/tooltip-button.module';

@NgModule({
  declarations: [
    EntryFeeCalcComponent,
    EntryFeeCalcItemComponent,
    EntryFeeInfoItemComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    AngularSvgIconModule,
    PricePipeModule,
    PreloadSpinnerModule,
    TooltipButtonModule,
  ],
  providers: [
    TranslatePipe,
  ],
  exports: [
    EntryFeeCalcComponent
  ]
})
export class EntryFeeCalcModule { }
